import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../i18n/hooks';
import './SurebetListError.css';

/**
 * SurebetListError - Error state with retry option
 * Shows error message and provides retry button
 */
const SurebetListError = ({ error, onRetry, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div 
      className={`surebet-list-error ${className}`}
      role="alert"
      aria-live="assertive"
    >
      <div className="surebet-list-error__container">
        {/* Error Icon */}
        <div className="surebet-list-error__illustration">
          <svg
            className="surebet-list-error__icon"
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M12 8V12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="16"
              r="1"
              fill="currentColor"
            />
          </svg>
        </div>

        {/* Error Message */}
        <h2 className="surebet-list-error__title">
          {t('surebets.list.errorTitle')}
        </h2>
        <p className="surebet-list-error__description">
          {error === 'ULTIMATE_REQUIRED'
            ? t('nearArb.upgradeRequired')
            : error === 'NEAR_ARB_UNAVAILABLE'
              ? t('nearArb.unavailable')
              : (error || t('surebets.list.errorDescription'))}
        </p>

        {/* Retry Button */}
        <button 
          className="surebet-list-error__retry-btn"
          onClick={onRetry}
          aria-label={t('surebets.list.retryButton')}
        >
          <svg
            className="surebet-list-error__retry-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 10V4M21 10H15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>{t('surebets.list.retryButton')}</span>
        </button>

        {/* Help Text */}
        <p className="surebet-list-error__help">
          {t('surebets.list.errorHelp')}
        </p>
      </div>
    </div>
  );
};

SurebetListError.propTypes = {
  error: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SurebetListError;

